<template>
	<div id="StepWizardHighlight" class="text-left">
		<div class="title-area">
			<h4>{{ stepName }}</h4>
			<p>Qual post ou imagem gostaria de destacar na página inicial?</p>
		</div>
		<div class="input-area">
			<masonry
				:cols="{ default: 3, 1000: 4, 700: 2 }"
				:key="keyMansory"
				:gutter="15"
			>
				<div
					v-for="(item, index) in itemsMedia"
					:key="index"
					class="mb-3 item--media pointer"
					:class="[findInSelected(item) ? 'active' : '']"
					@click="handleHighlight(item)"
				>
					<img
						:src="normalizeUrl(item.mainImage)"
						class="img-fluid"
						alt
					/>
					<span v-if="item.title" class="span--title">{{
						item.title
					}}</span>
				</div>
			</masonry>
		</div>
	</div>
</template>

<script>
	import axios from "axios";
	export default {
		name: "StepWizardHighlight",
		props: {
			stepName: {
				type: String,
				required: false,
			},
			stepDirt:{
				type: Boolean,
				default: false,
			},
			orientation: {
				type: String,
				required: false,
			},
		},
		data() {
			return {
				filters: [],
				itemsSelecteds: [],
				keyMansory: 1,
			};
		},
		created() {
			if (this.itemsMedia.length == 0) {
				if(this.orientation == 'foward'){
					this.$emit("nextStep");
				}else{
					this.$emit("trigger-back-step");
				}
			}
			setTimeout(() => {
				this.itemsSelecteds = this.$store.state.wizard.dataSite.highlights;
			}, 200);
		},
		computed: {
			itemsMedia() {
				let filteredPosts = [];
				let posts = this.$store.state.wizard.dataSite.createdItems.filter(
					(e) => e.page == "Blog" || e.page == "Novidades"
				);
				posts.forEach((item) => {
					item.posts.forEach((post) => {
						filteredPosts.push(post);
					});
				});
				let list = this.$store.state.wizard.dataSite.allImages;
				list.forEach((element) => {
					filteredPosts.push({
						id: element.id,
						title: "",
						mainImage: element.imageUrl,
					});
				});
				return filteredPosts.filter((item) => item.mainImage);
			},
		},
		mounted() {
			this.$emit("updateStep");
			this.$store.dispatch("WIZARD_SHOW_SKIP", [false]);
		},
		methods: {
			findInSelected(item) {
				return this.itemsSelecteds.some((element) => element.id == item.id);
			},
			handleHighlight(item) {
				let checkItem = this.itemsSelecteds.findIndex(picture => picture.id == item.id);
				if (checkItem >= 0) {
					this.itemsSelecteds.splice(checkItem, 1);
				} else {
					this.itemsSelecteds.push(item);
				}
			},
			normalizeUrl(item) {
				// Verifica se a URL já começa com process.env.CDN_URL
				if (item.startsWith(process.env.CDN_URL)) {
					return item;
				}
				return `${process.env.CDN_URL}${item}`;
			},
			updateHighlights() {
				this.$store.dispatch("UPDATE_HIGHLIGHTS", [this.itemsSelecteds]);
			},
			upscaleImages(files) {
				let token = localStorage.getItem("jwt");
				let siteId = localStorage.siteId;

				// coloca a url da cnd para enviar para a api fazer upscale
				for (let i = 0; i < files.length; i++) {
					files[i].mainImage = this.normalizeUrl(files[i].mainImage);
				}

				axios({
					method: "post",
					url: `${process.env.ROOT_API}/api/site/${siteId}/wizard/highlights/upscale`,
					data: {files : files},
					headers: {
					Authorization: "Bearer " + token,
					"Content-Type": "application/json"
					}
				}).then(response => {
					console.log('response')
					console.log(response);
				})
				.catch(error => {
					console.error('error');
					console.error(error);
				});
			}
		},
		watch: {
			itemsSelecteds() {
				this.updateHighlights();
				if (this.itemsSelecteds.length >= 1) {
					this.$store.dispatch("WIZARD_BLOCK_NEXT", [false]);
				} else {
					this.$store.dispatch("WIZARD_BLOCK_NEXT", [true]);
				}

				if (this.itemsSelecteds.length >= 3) {
					if(this.stepDirt == false){
						this.upscaleImages(this.itemsSelecteds)

						this.$store.dispatch("WIZARD_COMPLETE_STEP", [this.stepName]);
						this.$emit("nextStep");
					}
				}
			},
		},
		destroyed() {
			this.updateHighlights();
		},
	};
</script>

<style>
	.item--media {
		border: 2px solid transparent;
		position: relative;
		font-family: "Montserrat", sans-serif;
		font-size: 11px;
	}
	.item--media img {
		border-radius: 3px;
	}
	.item--media.active {
		border-radius: 6px;
		border: 2px solid var(--main-color);
	}
	.span--title {
		color: #fff;
		position: absolute;
		left: 5px;
		bottom: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/components/organisms/StepWizardHighlight.vue